import { action, observable } from 'mobx'

class Store {
  constructor(props) {
    this._props = props
  }

  @observable vertical_image = ''
  @observable clipModalVisible = false

  // 裁剪
  @action
  onCliped = res => {
    const { clipUrl } = res
    this.clipModalVisible = false
    // this.vertical_image = clipUrl; // 暂不需要显示
    // 执行回调
    this._props.onCliped(clipUrl, res)
  }

  // 删除
  @action
  onDelete = () => {
    this.vertical_image = ''
    this._props.onDelete('')
  }

  @action
  showVisibleClipModal = () => {
    this.clipModalVisible = true
  }

  @action
  hiddenVisibleClipModal = () => {
    this.clipModalVisible = false
    this.vertical_image = ''
  }

  // onOk
  @action
  onOk = () => {
    this.vertical_image = ''
    this._props.onOk()
  }

  // onCancel
  @action
  onCancel = () => {
    this.vertical_image = ''
    this._props.onCancel()
  }
}
export default Store
